import Calendar from 'react-calendar';
import styled, { css } from 'styled-components';
import { Button } from '@alefeducation/ui-elements-library-core/lib/Button';

export const StyledCalendar = styled(Calendar)<{ x: number; y: number }>`
  border-radius: 4.2px;
  box-shadow: 0 2px 4px 0 rgba(23, 28, 33, 0.06);
  border: solid 1px ${(props) => props.theme.colors.primary[40]};
  padding: 8px;
  background-color: white;
  width: 249px;
  z-index: 10000;
  position: fixed;
  top: ${(props) => props.y}px;
  left: ${(props) => props.x}px;

  &:before,
  &:after {
    bottom: 100%;
    left: unset;
    right: 10%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: white;
    border-width: 8px;
    margin-left: unset;
    margin-right: -8px;
  }

  &:before {
    border-color: rgba(61, 70, 77, 0);
    border-bottom-color: ${(props) => props.theme.colors.primary[40]};
    border-width: 9px;
    margin-left: unset;
    margin-right: -9px;
  }

  button {
    border: none;
    cursor: pointer;
    font: inherit;
    background-color: white;
    border-radius: unset;
    padding: unset;
    font-family: Signika, serif !important;
    font-weight: 400;
    line-height: 1.5;
  }

  button:disabled {
    opacity: 1;
  }

  .react-calendar {
    &__tile--active {
      background-color: ${(props) =>
        props.theme.colors.interactive[100]} !important;
      font-weight: bold !important;
      color: white;
    }

    &__navigation {
      display: flex;
      justify-content: space-between;
    }

    &__navigation__label,
    &__month-view__weekdays {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.5;
      color: ${(props) => props.theme.colors.text100};
    }

    &__navigation__prev-button {
      padding-left: 13px !important;
    }

    &__navigation__prev-button:disabled > svg {
      color: ${(props) => props.theme.colors.primary[10]};
    }

    &__navigation__next-button {
      padding-right: 13px !important;
    }

    &__month-view__weekdays {
      padding: 4px 0;
      border-bottom: 1px solid ${(props) => props.theme.colors.primary[40]};

      abbr {
        text-decoration: unset;
      }

      &__weekday {
        text-align: center;
      }
    }

    &__month-view__days {
      button:disabled {
        color: ${(props) => props.theme.colors.primary[20]};
        border: 0;
      }

      &__day:hover {
        border: 1px solid ${(props) => props.theme.colors.interactive[100]};
      }

      &__day {
        height: 33px;
        border-radius: 4px !important;
        font-size: 14px;
        font-weight: 100;

        &--neighboringMonth {
          color: ${(props) => props.theme.colors.primary[60]};
        }
      }
    }
  }
`;

export const StyledDateButton = styled(Button)`
  width: 100%;
  margin: 8px 0;
  justify-content: flex-start;
  height: 36px;
  padding-left: 16px;
  padding-right: 16px;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};

  span {
    display: flex;
    gap: 4px;
  }

  ${(props) =>
    props.disabled
      ? css`
          :active,
          :hover,
          :focus {
            box-shadow: rgb(182, 187, 193) 0px 0px 0px 1px;
          }
        `
      : ''};
`;
